import React, { useState, useEffect } from "react";
import "../../../../assets/scss/home.scss";
import "../../../../assets/scss/tests.scss";
import "flatpickr/dist/flatpickr.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import x_mark from "../../../../assets/images/courses/group.svg";
import PaginatedItemsWritten from "../../../../components/tables/paginationResultWritten";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
const ResultFreeWrittenTest = (props) => {
    const location = useLocation();
    const testType = location.state?.testType;
    const [array, setArray] = useState(location.state?.array);
    let score = location.state?.score;
    let note_id = location.state?.note_id;
    let noteData = location.state?.noteData;
    let canDoIt = location.state?.canDoIt;
    let testData = location.state?.testData;
    const history = useHistory();

    function checkTypeTest(count) {
        if (testType.length > 1) {
            return `Written - ${count} Questions`;
        } else {
            return `${testType[0]} - ${count} Questions`;
        }
    }

    const redoTest = async () => {
        history.push({
            pathname: "/freeTest",
            state: {
                array,
                note_id,
                testType,
                testData,
                noteData,
                canDoIt,
            },
        });
    };

    const jaccardFunc = (text1, text2) => {
        const preprocessText = (text) => {
            if (typeof text !== "string") {
                text = text.toString();
            }
            text = text.toLowerCase(); // Convert text to lowercase
            text = text.replace(/[^\w\s]/g, ""); // Remove punctuation
            return text.split(/\s+/); // Tokenize the text
        };

        const set1 = new Set(preprocessText(text1));
        const set2 = new Set(preprocessText(text2));
        const intersection = [...set1].filter((x) => set2.has(x)).length;
        const union = set1.size + set2.size - intersection;
        const jaccardSimilarity = intersection / union;
        return jaccardSimilarity;
    };

    return (
        <div>
            <div className="homeCard resultCard mt-4">
                <div>
                    <div className="resultHeader">
                        <h1>Results</h1>

                        <img
                            src={x_mark}
                            alt="x_mark"
                            onClick={() => {
                                history.push({
                                    pathname: "/tryforfree",
                                });
                            }}
                        />
                    </div>
                </div>

                <div className="accountingHeaderContent mt-4">
                    <h1>{testData?.test_name}</h1>
                </div>
                <div className="testType">
                    <div>
                        <span>{checkTypeTest(array.length)}</span>
                    </div>
                </div>
                <div className="buttonsDivResult mt-4">
                    <button
                        className="finish"
                        onClick={() => {
                            history.push({
                                pathname: "/tryforfree",
                            });
                        }}
                    >
                        Finish
                    </button>
                    <button
                        onClick={() => {
                            redoTest();
                        }}
                    >
                        Re-take
                    </button>
                </div>

                <div className="pgItems">
                    <PaginatedItemsWritten
                        itemsPerPage={4}
                        items={array}
                        scoreResult={score}
                        test_id={null}
                        isCreate={false}
                    />
                </div>
            </div>
        </div>
    );
};

export default ResultFreeWrittenTest;
